import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "Meus dados est\u00e3o seguros?",
    answer:
      "Sim! Utilizamos o Supabase Cloud com criptografia de ponta a ponta. Seus dados s\u00e3o protegidos por Row Level Security (RLS), o que significa que apenas voc\u00ea tem acesso \u00e0s suas informa\u00e7\u00f5es financeiras. Al\u00e9m disso, toda comunica\u00e7\u00e3o \u00e9 feita via HTTPS com certificados SSL.",
  },
  {
    question: "Posso cancelar a qualquer momento?",
    answer:
      "Claro! Voc\u00ea pode cancelar sua assinatura a qualquer momento diretamente nas configura\u00e7\u00f5es da sua conta. Ao cancelar, voc\u00ea continua com acesso ao plano at\u00e9 o final do per\u00edodo j\u00e1 pago. Ap\u00f3s isso, sua conta volta automaticamente para o plano gratuito.",
  },
  {
    question: "Como funciona o per\u00edodo de teste?",
    answer:
      "Os planos Starter e Colab oferecem 7 dias de teste gr\u00e1tis. Durante esse per\u00edodo, voc\u00ea tem acesso a todos os recursos do plano escolhido. Se n\u00e3o quiser continuar, basta cancelar antes do t\u00e9rmino do teste \u2014 voc\u00ea n\u00e3o ser\u00e1 cobrado.",
  },
  {
    question: "Preciso cadastrar cart\u00e3o para o plano gratuito?",
    answer:
      "N\u00e3o! O plano B\u00e1sico (gratuito) n\u00e3o exige cart\u00e3o de cr\u00e9dito. Voc\u00ea pode usar a plataforma gratuitamente pelo tempo que quiser. O cart\u00e3o s\u00f3 \u00e9 necess\u00e1rio se voc\u00ea decidir fazer upgrade para um plano pago.",
  },
  {
    question: "Posso mudar de plano depois?",
    answer:
      "Sim! Voc\u00ea pode fazer upgrade ou downgrade do seu plano a qualquer momento. Ao fazer upgrade, o valor \u00e9 ajustado proporcionalmente. Ao fazer downgrade, a mudan\u00e7a entra em vigor no pr\u00f3ximo ciclo de cobran\u00e7a.",
  },
];

export function FAQSection() {
  return (
    <section id="faq" className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-14">
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-4">
            Perguntas frequentes
          </h2>
          <p className="text-muted-foreground text-lg max-w-xl mx-auto">
            Tire suas d&uacute;vidas sobre o Next AI Finance.
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="text-left text-base">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
